import { render } from "./FooterComponent.vue?vue&type=template&id=e373a322"
const script = {}
script.render = render

export default script